import type { SortValue } from './types';

export type AlgoliaEnvironmentSuffix = 'dev' | 'prod';

function getAlgoliaIndex({
  sort,
  language,
  environment,
}: {
  sort?: SortValue;
  environment: AlgoliaEnvironmentSuffix;
  language: string;
}) {
  const baseIndex = ['webshop_products', language, environment].join('_');

  switch (sort) {
    case 'price_asc':
      return `${baseIndex}_sort_price_asc`;
    case 'price_desc':
      return `${baseIndex}_sort_price_desc`;
    case 'release_date_desc':
      return `${baseIndex}_sort_release_date_desc`;
    case 'release_date_asc':
      return `${baseIndex}_sort_release_date_asc`;
    default:
      return baseIndex;
  }
}

export { getAlgoliaIndex };
